import React, { useEffect, useState } from "react";
import { getPaymentHistory } from "../api/api";
import "./PaymentHistory.css";

const PaymentHistory = () => {
  const [paymentHistory, setPaymentHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPaymentHistory = async () => {
      try {
        const userDatas = localStorage.getItem("currentUser");
        const parsedUserData = JSON.parse(userDatas);
        const _id = parsedUserData?.id || parsedUserData?._id;

        const values = { user_id: _id };
        const payment = await getPaymentHistory(values);

        if (payment?.data) {
          const sortedData = payment.data.sort(
            (a, b) => new Date(b.created_at) - new Date(a.created_at)
          );
          setPaymentHistory(sortedData);
        }
      } catch (error) {
        console.log("Error fetching payment history:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPaymentHistory();
  }, []);

  return (
    <div className="paymenthistory-container">
      <h2 className="payment-title">Payment History</h2>

      {loading ? (
        <div className="loaderdiv">
          <div className="loader"></div>
        </div>
      ) : paymentHistory.length > 0 ? (
        <div className="payment-list">
          {paymentHistory.map((item) => (
            <div key={item.id} className="payment-card">
              <div className="payment-row">
                <span className="product-name">
                  {item?.plans?.name || item.product_name}
                </span>
              </div>

              <div className="payment-row">
                <span className="label">Purchased on:</span>
                <span className="value">
                  {new Date(item.created_at).toLocaleDateString()}
                </span>
              </div>

              {item?.plans?.frequency && (
                <div className="payment-row">
                  <span className="label">Frequency:</span>
                  <span className="value">
                    {item.plans.frequency.charAt(0).toUpperCase() +
                      item.plans.frequency.slice(1)}
                  </span>
                </div>
              )}

              {item?.plans?.frequency && (
                <div className="payment-row">
                  <span className="label">Amount</span>
                  <span className="price">
                    {item.currency_symbol}
                    {item.price}
                  </span>
                </div>
              )}

              {item?.plans?.duration && (
                <div className="payment-row">
                  <span className="label">Duration:</span>
                  <span className="value">{item.plans.duration}</span>
                </div>
              )}
            </div>
          ))}
        </div>
      ) : (
        <p className="no-data">No payment history found.</p>
      )}
    </div>
  );
};

export default PaymentHistory;
